import styled from 'styled-components'

const SelectBoxes = styled.div`
  display: flex;

  div + div {
    margin-left: 20px;
  }
`

export default SelectBoxes
